<template>
  <div class="my-pooq-content-body">
    <router-view name="popupChangePayment"></router-view>
    <div class="mypooq-list">
      <my-pooq-empty-list v-if="showEmptyList" info-text="이용권 결제 내역이 없어요."></my-pooq-empty-list>
      <ul class="mypooq-voucher-list">
        <li v-for="(subscription, index) in subscriptionList" :key="'subscription_' + index"
            :class="subscription.status !== 'y' ? 'expire' : ''">
          <span class="voucher-box">
            <div class="badge-group">
              <span class="badge ui" v-if="subscription.status === 'y'">이용중</span>
              <span class="badge ui" v-if="subscription.autopayment === 'true' && subscription.autopaymentstatus === 'y' && subscription.chargetypeid !== '220'">자동결제 이용중</span>
              <span class="badge ui negative" v-if="subscription.autopayment === 'false' && subscription.autopaymentstatus === 'n'">자동결제 비대상</span>
              <span class="badge ui positive" v-if="subscription.autopayment === 'true' && subscription.autopaymentstatus === 'n'">해지신청 완료</span>
              <span class="badge ui expire" v-if="subscription.status === 'n'">이용기간 만료</span>
            </div>

            <span class="voucher-info">
              <span class="product-txt">{{subscription.productgroupname}}</span>
              <span>{{subscription.productname}}</span>
              <span v-html="replaceDot(subscription.attributetext)"></span>
              <span class="voucher-skt" v-if="isSktStream(subscription)">{{ isSktStreamMsg(subscription) }}</span>
            </span>
            <span class="voucher-box-bottom">
                <span class="voucher-box-bottom-item">
                  <span>이용</span>
                  <i class="middle-dot"></i>
                  <span>{{subscription.startdate}}</span>
                </span>
                <span class="voucher-box-bottom-item">
                  <span>만료</span>
                  <i class="middle-dot"></i>
                  <span>{{subscription.enddate}}</span>
                </span>
                <span class="voucher-box-bottom-item">
                  <span>구매금액</span>
                  <i class="middle-dot"></i>
                  <span>{{subscription.amount}}</span>
                </span>
                <span class="voucher-box-bottom-item">
                  <span>다운로드</span>
                  <i class="middle-dot"></i>
                  <span>{{download(subscription)}}</span>
                </span>
                <span class="voucher-box-bottom-item">
                  <span>결제방법</span>
                  <i class="middle-dot"></i>
                  <span>{{subscription.paymentmethod}}</span>
                </span>
            </span>
          </span>
          <span class="voucher-change" v-if="subscription.autopayment === 'true' && !isSubscriptionIosAndGoogle(subscription)">
              <button type="button" class="voucher-cancel" v-if="subscription.autopaymentstatus === 'y'" @click.prevent="()=>unsubscribe(subscription)">자동결제 해지</button>
              <button type="button" class="voucher-cancel" v-if="subscription.autopaymentstatus === 'n'" @click.prevent="()=>cancelUnsubscribe(subscription)">자동결제 해지 취소</button>
              <button type="button" class="method-change" v-if="subscription.changemethod === 'y'" @click.prevent="()=>changePaymentMethod(subscription)">결제수단 변경</button>
          </span>
        </li>
      </ul>
      <div class="partner-info" v-if="subscriptionList && subscriptionList.length > 0">
        <p class="dot-text">Wavve 홈페이지가 아닌 제휴 사이트에서 구매한 결합상품(SKT, Bugs에서 구매한 상품 등)의 경우 Wavve 사이트에서 해지가 불가능합니다. 제휴사에 문의해주세요.</p>
        <p class="dot-text">이용권 구매 후 콘텐츠 미사용 시, 7일 이내에 청약 철회가 가능합니다.</p>
        <p class="dot-text">이용권 구매 후 7일이 경과 되었거나 콘텐츠를 사용한 경우 부분 환불이 진행될 수 있습니다. (할인 이벤트를 받아 이용권을 구매한 경우 할인 미적용 기준으로 환불 금액이 정산 됩니다.)</p>
        <p class="dot-text">이용권 구매 후 청약 철회 또는 부분 환불을 원하시면 웨이브 <a :href="getInquiryUrl()" :style="highlightTextStyle">고객센터</a>에 연락해 주시기 바랍니다.</p>
      </div>
      <div class="my-inner-wrap" v-if="isSubscriptionManagement">
        <a href="#" @click.prevent="manageSubscription()" class="btn btn-large btn-radius btn-positive">구독관리</a>
      </div>
      <div class="my-inner-wrap" v-else>
        <a href="#" @click.prevent="moveToVoucher()" class="btn btn-large btn-radius btn-positive">이용권 변경하기</a>
      </div>
    </div>
  </div>
</template>

<script>
import { MyPooqService } from '@/common/api/api.service'
import { replace, get, defaultTo } from 'lodash'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import utils from '@/common/util/utils'
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS } from '@/common/devicetype.const'
import { PATH_NAME_VOUCHER_INDEX } from '@/common/router.const'
import { isApp } from '@/common/util/common'
import {
  MSG_INFO_ONLY_GOOGLE_USED,
  MSG_INFO_ONLY_IOS_USED,
  MSG_INFO_ONLY_SUBSCRIBE_APP_PAGE,
  PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE
} from '@/common/constant'
export default {
  name: 'MyPooqSubscriptionTicket',
  components: {
    MyPooqEmptyList
  },
  data () {
    return {
      subscriptionList: [],
      // dataRevocationDefense: undefined, // 해지 방어 팝업용 데이터
      isUnsubscribe: false, // 해지 방어 팝업용 플래그 true: 1차 해지방어, false: 2차 해지방어
      // isShowRevocationDefense: false, // 해지 방어 팝업 표시 여부
      showEmptyList: false,
      device: utils.cookies.getDevice(),
      pgName: utils.getPgName(),
      highlightTextStyle: {
        color: '#A5A5A5',
        textDecoration: 'underline',
      }
    }
  },
  computed: {
    isSubscriptionManagement () {
      return this.device === DEVICE_TYPE_IOS || this.pgName === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE
    }
  },
  methods: {
    setData () {
      MyPooqService.purchaseProduct({
        offset: 0,
        limit: 20,
        orderby: 'new',
        autopayment: 'y',
        producttype: 'pass',
        enddate: '',
        startdate: '',
        device: 'mobile'
      }).then(({ data }) => {
        this.subscriptionList = data.list || []
        this.subscriptionList = this.subscriptionList.map((ticket) => {
          let resTicket = Object.assign({}, ticket)
          let amount = ''
          if (isNaN(ticket.amount)) {
            amount = ticket.amount
          } else {
            amount = ticket.amount + '원'
          }
          resTicket.amount = amount
          return resTicket
        })
        this.showEmptyList = this.subscriptionList.length === 0
      })
    },
    unsubscribe (subscription) {
      this.$router.push({
        name: 'subscription_cancel',
        params: {
          subscription: subscription,
          isUnsubscribe: true
        },
        query: {
          targetdm: get(this.$route, ['query', 'targetdm'], '')
        }
      })
    },
    cancelUnsubscribe (subscription) {
      this.$router.push({
        name: 'subscription_cancel',
        params: {
          subscription: subscription,
          isUnsubscribe: false
        },
        query: {
          targetdm: get(this.$route, ['query', 'targetdm'], '')
        }
      })
    },
    changePaymentMethod (subscription) {
      this.$router.push('/popupChangePayment?transationid=' + subscription.transactionid)
    },
    iosManageSubscription () {
      if (this.device === DEVICE_TYPE_IOS) {
        location.href = 'captvpooq://voucher/unsubscription'
      } else {
        utils.alert(MSG_INFO_ONLY_IOS_USED)
      }
    },
    googleManageSubscription (subscription) {
      const url = `https://play.google.com/store/account/subscriptions?sku=${subscription.productid}&package=kr.co.captv.pooqV2`
      const goManagePage = confirm('Google 앱 내 구매 이용권은 Google play 페이지에서만 해지 / 해지 취소가 가능합니다. Google play 페이지로 이동합니다.')
      if (goManagePage) {
        if (utils.cookies.getDevice() === DEVICE_TYPE_ANDROID) {
          location.href = url
        } else {
          window.open(url)
        }
      }
    },
    manageSubscription () {
      const subscription = get(this.subscriptionList, '0', {})
      const isIos = get(subscription, 'paymentmethod', '').startsWith('iTunes')
      const isGoogle = get(subscription, 'paymentmethod', '').startsWith('구글')
      if (!isGoogle && !isIos) {
        utils.alert(MSG_INFO_ONLY_SUBSCRIBE_APP_PAGE)
        return
      }
      if (this.device === DEVICE_TYPE_IOS) {
        if (isGoogle) {
          utils.alert(MSG_INFO_ONLY_GOOGLE_USED)
          return
        }
        this.iosManageSubscription(subscription)
      } else if (this.pgName === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE) {
        if (isIos) {
          utils.alert(MSG_INFO_ONLY_IOS_USED)
          return
        }
        this.googleManageSubscription(subscription)
      }
    },
    replaceDot (value) {
      if (value.indexOf('$O$') > -1) {
        return replace(value, new RegExp('\\$O\\$', 'g'), '<i class="icon-dotted"></i>')
      } else {
        return value
      }
    },
    download (subscription) {
      if (+subscription.downloadcount < +subscription.downloadlimit) {
        return +subscription.downloadlimit + '회'
      }
      return '불가'
    },
    isSktStream (subscription) {
      return defaultTo(get(subscription, 'issktstream', 'y'), 'y') === 'y'
    },
    isSktStreamMsg (subscription) {
      return defaultTo(get(subscription, 'issktstreammessage', ''), '')
    },
    moveToVoucher () {
      const subscription = get(this.subscriptionList, '0', {}) // 이용내역 최신 버전으로 확인
      const alertText = (voucherType) => {
        return `${voucherType} 앱 내 구매 이용권은 ${voucherType} 페이지에서만 변경 가능합니다.`
      }
      const isIos = get(subscription, 'paymentmethod', '').startsWith('iTunes')
      const isGoogle = get(subscription, 'paymentmethod', '').startsWith('구글')
      if (isIos || isGoogle) {
        isIos ? utils.alert(alertText('IOS')) : utils.alert(alertText('google'))
        return
      }
      this.$router.push({
        name: PATH_NAME_VOUCHER_INDEX,
        query: {
          pgname: this.pgName,
          device: this.device
        }
      })
    },
    isSubscriptionIosAndGoogle (subscription) {
      return ((get(subscription, 'chargetypeid', '') === '220' && get(subscription, 'paymentmethod', '').startsWith('구글')) ||
        get(subscription, 'paymentmethod', '').startsWith('iTunes'))
    },
    getInquiryUrl () {
      return isApp() ? 'captvpooq://customer/qna/inquiry' : 'https://member.wavve.com/mobile/customer/qna/ask?device=mobile'
    }
  },
  mounted () {
    this.setData()
  }
}
</script>
<style lang="scss" scoped>
  .product-name{
    font-size: 12px;
  }
  .middle-dot {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 10px;
    margin: 0 4px 0 2px;
    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 2px;
      height: 2px;
      background-color: #a5a5a5;
      border-radius: 1px;
    }
  }
  .partner-info{
    width: 100%;
    margin: 20px 0;
    color: #717171;
    .dot-text {
      position: relative;
      font-size: 12px;
      line-height: 18px;
      padding: 0 10px 0 17px;
    }
  }
  .partner-info .dot-text:before{
    position: absolute;
    top: 9px;
    left: 10px;
    content: '';
    width: 2px;
    height: 2px;
    background-color: #717171;
    border-radius: 1px;
  }
</style>
